import { useEffect } from 'react';
import { registerSW } from 'virtual:pwa-register';

/**
 * Always apply waiting service-worker updates. A confirm() prompt previously let
 * users dismiss refreshes and keep serving stale portal JS — including outdated
 * cancellation-fee copy (hardcoded ₱0 for Requested trips).
 */
export function usePwaRegister() {
  useEffect(() => {
    const updateSW = registerSW({
      immediate: true,
      onNeedRefresh() {
        void updateSW(true);
      },
      onOfflineReady() {
        console.info('DispatchDash is ready for offline use');
      },
    });
  }, []);
}
